export default __webpack_public_path__ + "static/media/cybersecurity-data-architecture.2a5162a8.svg";